import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

const RegexFilteredInput = ({ regex, onChange, disabled, readOnly, value, ref, ...other }) => {
  const onKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    const char = String.fromCharCode(charCode);
    if (!char.match(regex)) {
      e.preventDefault();
    }
  };

  const onInputChange = (e) => {
    const newInputValue = e.target.value;

    if (newInputValue && !regex.test(e.target.value)) {
      e.target.value = value;
      return;
    }

    onChange(e);
  };

  return (
    <TextField
      variant="outlined"
      onChange={onInputChange}
      onKeyPress={onKeyPress}
      inputRef={ref}
      InputProps={{
        inputProps: {
          readOnly,
          value,
          ...other.inputProps,
        },
      }}
      autoFocus
      readOnly={readOnly}
      disabled={disabled}
      {...other}
    />
  );
};

RegexFilteredInput.propTypes = {
  regex: PropTypes.instanceOf(RegExp).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  ref: PropTypes.object,
  readOnly: PropTypes.bool,
  other: PropTypes.object,
};

RegexFilteredInput.defaultProps = {
  disabled: false,
  value: '',
  ref: null,
  readOnly: false,
  other: null,
};

export default RegexFilteredInput;
